<template>
  <v-app-bar app class="sub-topbar" color="white">
    <v-container class="d-flex align-center h-full gap-3">
      <v-btn icon @click="toggleDrawer">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-toolbar-title class="d-flex align-center">
        <router-link to="/app">
          <v-img
            class="logo"
            width="30"
            height="30"
            src="@/assets/images/icon.svg"
            alt=""
          />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="d-flex align-center gap-2">
        <DesktopClientIndicator />
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              small
              color="grey lighten-2"
              v-bind="attrs"
              v-on="on"
              elevation="0"
            >
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="logout">
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title> Sair </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-container>
  </v-app-bar>
</template>


<script>
// import HeaderNavbar from '@/views/home/header-navbar'
// import Navbar from '@/views/home/navbar'
import { directive as onClickaway } from "vue-clickaway";
import DesktopClientIndicator from "@/components/global/DesktopClientIndicator.vue";

export default {
  name: "BaseAppBar",
  components: {
    DesktopClientIndicator,
  },
  directives: {
    onClickaway: onClickaway,
  },
  data: () => ({
    colorNav: false,
    dialog: false,
    isToggleNavbar: false,
    drawer: false,
    group: null,
  }),
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/");
    },

    toggleDrawer() {
      this.$emit("input", !this.value);
    },
    toggleNavbar() {
      if (this.$route.path == "/") {
        this.isToggleNavbar = false;
      } else {
        this.isToggleNavbar = !this.isToggleNavbar;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$z-index-sub-topbar: 2;
$md: 959px;
$z-99: 99;
.z-999 {
  z-index: 999;
}
.top-bar {
  height: 40px;
  display: flex;
  align-items: center;
}

.navbar {
  height: 60px;
  width: 100%;
  z-index: 2;
  box-shadow: rgb(43 52 69 / 10%) 0px 16px 16px -16px !important;
  &.v-app-bar--is-scrolled {
    position: relative;
    top: 64px;
    margin-bottom: 64px;
    box-shadow: rgb(43 52 69 / 10%) 0px 16px 16px -16px !important;
    // box-shadow: none !important;
  }
  @media (max-width: 992px) {
    display: none;
  }
}
.search-bar {
  .search-bar-dropdown {
    position: absolute;
    right: 0;
    border-radius: 22px;

    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    height: 40px;
    box-shadow: none !important;
    @media (max-width: $md) {
      display: none;
    }
  }
  ::v-deep .v-text-field__details {
    display: none;
  }
}

// toggleNavbarButton
.navbar-toggle-dropdown {
  z-index: 98;
  display: none;
  &.open {
    display: block;
    top: 64px;
  }
}
</style>
